import { useState } from 'react';

const mapZones = [
  {
    id: 'express',
    label: 'Экспресс (15–60 мин)',
    color: '#ff2d78',
    desc: 'Москва в пределах МКАД, центр СПб',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'standard',
    label: 'Стандарт (2–4 часа)',
    color: '#00f5ff',
    desc: 'Москва и МО, СПб и ЛО, города-миллионники',
    icon: 'ri-truck-line',
  },
  {
    id: 'pickup',
    label: 'Самовывоз',
    color: '#39ff14',
    desc: '1 000+ аптек по всей России',
    icon: 'ri-store-2-line',
  },
  {
    id: 'post',
    label: 'Почта / СДЭК',
    color: '#f0ff00',
    desc: 'Все регионы России, 3–10 дней',
    icon: 'ri-mail-send-line',
  },
];

const pharmacyPoints = [
  { id: 1, name: 'NeonPharma Арбат', address: 'ул. Арбат, 12', metro: 'Арбатская', hours: '08:00–22:00', lat: 55.7520, lng: 37.5920 },
  { id: 2, name: 'NeonPharma Тверская', address: 'ул. Тверская, 7', metro: 'Тверская', hours: '24/7', lat: 55.7650, lng: 37.6050 },
  { id: 3, name: 'NeonPharma Сокол', address: 'Ленинградский пр., 45', metro: 'Сокол', hours: '08:00–23:00', lat: 55.7980, lng: 37.5130 },
  { id: 4, name: 'NeonPharma Таганская', address: 'ул. Таганская, 3', metro: 'Таганская', hours: '09:00–21:00', lat: 55.7390, lng: 37.6530 },
  { id: 5, name: 'NeonPharma Митино', address: 'ул. Митинская, 28', metro: 'Митино', hours: '08:00–22:00', lat: 55.8350, lng: 37.3560 },
  { id: 6, name: 'NeonPharma Выхино', address: 'ул. Ташкентская, 9', metro: 'Выхино', hours: '24/7', lat: 55.7180, lng: 37.8420 },
];

const DeliveryMap = () => {
  const [activeZone, setActiveZone] = useState<string | null>(null);
  const [selectedPoint, setSelectedPoint] = useState<typeof pharmacyPoints[0] | null>(null);
  const [mapCity, setMapCity] = useState<'moscow' | 'spb'>('moscow');

  const moscowMapUrl =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d144699.5!2d37.3858!3d55.7558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54a50b315e573%3A0xa886bf5a3d9b2e68!2z0JzQvtGB0LrQstCw!5e0!3m2!1sru!2sru!4v1700000000000!5m2!1sru!2sru';

  const spbMapUrl =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d100500!2d30.3141!3d59.9386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4696378cc74a65ed%3A0x6dc7673fab848eff!2z0KHQsNC90LrRgi3Qn9C10YLQtdGA0LHRg9GA0LM!5e0!3m2!1sru!2sru!4v1700000000001!5m2!1sru!2sru';

  return (
    <section className="px-6 lg:px-12 pb-16">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/60 mb-2">КАРТА ПОКРЫТИЯ</p>
          <h2 className="font-orbitron font-black text-2xl md:text-3xl text-white">ЗОНЫ ДОСТАВКИ</h2>
          <div className="mt-2 w-12 h-0.5" style={{ background: 'linear-gradient(90deg, #00f5ff, transparent)' }} />
          <p className="font-mono text-xs text-white/35 mt-3 max-w-xl leading-relaxed">
            Выберите зону на карте, чтобы узнать условия доставки в вашем районе. Более 1 000 аптек для самовывоза по всей России.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left panel: zones + points */}
          <div className="flex flex-col gap-4">
            {/* City switcher */}
            <div className="flex gap-2 p-1 rounded-full" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              {(['moscow', 'spb'] as const).map((city) => (
                <button
                  key={city}
                  onClick={() => setMapCity(city)}
                  className="whitespace-nowrap flex-1 py-2 rounded-full font-mono text-xs cursor-pointer transition-all duration-300"
                  style={
                    mapCity === city
                      ? { background: '#00f5ff', color: '#050508', fontWeight: 700 }
                      : { color: 'rgba(255,255,255,0.4)' }
                  }
                >
                  {city === 'moscow' ? 'Москва' : 'Санкт-Петербург'}
                </button>
              ))}
            </div>

            {/* Zone legend */}
            <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(255,255,255,0.07)' }}>
              <div className="px-4 py-3" style={{ background: 'rgba(255,255,255,0.03)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                <p className="font-mono text-[10px] tracking-[0.25em] text-white/30">ЗОНЫ ПОКРЫТИЯ</p>
              </div>
              {mapZones.map((zone) => (
                <button
                  key={zone.id}
                  onClick={() => setActiveZone(activeZone === zone.id ? null : zone.id)}
                  className="w-full flex items-center gap-3 px-4 py-3 cursor-pointer transition-all duration-200 text-left"
                  style={{
                    background: activeZone === zone.id ? `${zone.color}08` : 'transparent',
                    borderBottom: '1px solid rgba(255,255,255,0.04)',
                  }}
                >
                  <div
                    className="w-3 h-3 rounded-full shrink-0"
                    style={{
                      background: zone.color,
                      boxShadow: activeZone === zone.id ? `0 0 8px ${zone.color}` : 'none',
                    }}
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <i className={`${zone.icon} text-xs`} style={{ color: zone.color }} />
                      <span className="font-mono text-xs text-white/70 truncate">{zone.label}</span>
                    </div>
                    <p className="font-mono text-[10px] text-white/30 mt-0.5 leading-tight">{zone.desc}</p>
                  </div>
                  {activeZone === zone.id && (
                    <i className="ri-eye-line text-xs shrink-0" style={{ color: zone.color }} />
                  )}
                </button>
              ))}
            </div>

            {/* Pharmacy points list */}
            <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(57,255,20,0.15)' }}>
              <div className="px-4 py-3 flex items-center justify-between" style={{ background: 'rgba(57,255,20,0.04)', borderBottom: '1px solid rgba(57,255,20,0.1)' }}>
                <p className="font-mono text-[10px] tracking-[0.25em] text-white/30">АПТЕКИ НА КАРТЕ</p>
                <span className="font-mono text-[10px] px-2 py-0.5 rounded-full" style={{ background: 'rgba(57,255,20,0.12)', color: '#39ff14' }}>
                  {pharmacyPoints.length} точек
                </span>
              </div>
              <div className="max-h-64 overflow-y-auto">
                {pharmacyPoints.map((point) => (
                  <button
                    key={point.id}
                    onClick={() => setSelectedPoint(selectedPoint?.id === point.id ? null : point)}
                    className="w-full flex items-start gap-3 px-4 py-3 cursor-pointer transition-all duration-200 text-left"
                    style={{
                      background: selectedPoint?.id === point.id ? 'rgba(57,255,20,0.06)' : 'transparent',
                      borderBottom: '1px solid rgba(255,255,255,0.04)',
                    }}
                  >
                    <div
                      className="w-6 h-6 flex items-center justify-center rounded-full shrink-0 mt-0.5"
                      style={{
                        background: selectedPoint?.id === point.id ? 'rgba(57,255,20,0.2)' : 'rgba(255,255,255,0.06)',
                        border: `1px solid ${selectedPoint?.id === point.id ? 'rgba(57,255,20,0.5)' : 'rgba(255,255,255,0.1)'}`,
                      }}
                    >
                      <i className="ri-map-pin-line text-[10px]" style={{ color: selectedPoint?.id === point.id ? '#39ff14' : 'rgba(255,255,255,0.3)' }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-mono text-xs text-white/70 leading-tight">{point.name}</p>
                      <p className="font-mono text-[10px] text-white/30 mt-0.5">{point.address}</p>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="flex items-center gap-1 font-mono text-[10px]" style={{ color: '#39ff14' }}>
                          <i className="ri-subway-line text-[9px]" />
                          {point.metro}
                        </span>
                        <span className="font-mono text-[10px] text-white/25">{point.hours}</span>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Map */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {/* Map container */}
            <div
              className="relative rounded-2xl overflow-hidden"
              style={{
                border: '1px solid rgba(0,245,255,0.2)',
                height: '480px',
                boxShadow: '0 0 40px rgba(0,245,255,0.06)',
              }}
            >
              {/* Neon corner accents */}
              <div className="absolute top-0 left-0 w-8 h-8 z-10 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-0.5" style={{ background: '#00f5ff' }} />
                <div className="absolute top-0 left-0 w-0.5 h-full" style={{ background: '#00f5ff' }} />
              </div>
              <div className="absolute top-0 right-0 w-8 h-8 z-10 pointer-events-none">
                <div className="absolute top-0 right-0 w-full h-0.5" style={{ background: '#00f5ff' }} />
                <div className="absolute top-0 right-0 w-0.5 h-full" style={{ background: '#00f5ff' }} />
              </div>
              <div className="absolute bottom-0 left-0 w-8 h-8 z-10 pointer-events-none">
                <div className="absolute bottom-0 left-0 w-full h-0.5" style={{ background: '#00f5ff' }} />
                <div className="absolute bottom-0 left-0 w-0.5 h-full" style={{ background: '#00f5ff' }} />
              </div>
              <div className="absolute bottom-0 right-0 w-8 h-8 z-10 pointer-events-none">
                <div className="absolute bottom-0 right-0 w-full h-0.5" style={{ background: '#00f5ff' }} />
                <div className="absolute bottom-0 right-0 w-0.5 h-full" style={{ background: '#00f5ff' }} />
              </div>

              {/* Scan line overlay */}
              <div className="absolute inset-0 z-10 pointer-events-none" style={{ background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,245,255,0.015) 2px, rgba(0,245,255,0.015) 4px)' }} />

              <iframe
                src={mapCity === 'moscow' ? moscowMapUrl : spbMapUrl}
                width="100%"
                height="100%"
                style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg) saturate(0.7) brightness(0.85)' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Карта зон доставки NeonPharma"
              />

              {/* Zone overlay badges */}
              {activeZone && (
                <div className="absolute top-4 left-4 z-20 pointer-events-none">
                  {mapZones.filter((z) => z.id === activeZone).map((zone) => (
                    <div
                      key={zone.id}
                      className="flex items-center gap-2 px-3 py-2 rounded-xl font-mono text-xs"
                      style={{ background: `${zone.color}20`, border: `1px solid ${zone.color}60`, color: zone.color, backdropFilter: 'blur(8px)' }}
                    >
                      <i className={`${zone.icon}`} />
                      <span>{zone.label}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* Selected pharmacy popup */}
              {selectedPoint && (
                <div
                  className="absolute bottom-4 left-4 right-4 z-20 p-4 rounded-xl"
                  style={{ background: 'rgba(5,5,8,0.92)', border: '1px solid rgba(57,255,20,0.4)', backdropFilter: 'blur(12px)' }}
                >
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0" style={{ background: 'rgba(57,255,20,0.15)', border: '1px solid rgba(57,255,20,0.4)' }}>
                        <i className="ri-store-2-line text-sm" style={{ color: '#39ff14' }} />
                      </div>
                      <div>
                        <p className="font-orbitron font-bold text-xs text-white">{selectedPoint.name}</p>
                        <p className="font-mono text-[10px] text-white/40 mt-0.5">{selectedPoint.address}</p>
                        <div className="flex items-center gap-3 mt-1.5">
                          <span className="flex items-center gap-1 font-mono text-[10px]" style={{ color: '#39ff14' }}>
                            <i className="ri-subway-line" />
                            м. {selectedPoint.metro}
                          </span>
                          <span className="flex items-center gap-1 font-mono text-[10px] text-white/35">
                            <i className="ri-time-line" />
                            {selectedPoint.hours}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setSelectedPoint(null)}
                      className="w-6 h-6 flex items-center justify-center rounded-full cursor-pointer shrink-0"
                      style={{ background: 'rgba(255,255,255,0.06)' }}
                    >
                      <i className="ri-close-line text-xs text-white/40" />
                    </button>
                  </div>
                  <a
                    href={`https://maps.google.com/?q=${selectedPoint.address},+Москва`}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="whitespace-nowrap mt-3 flex items-center justify-center gap-2 py-2 rounded-lg font-mono text-xs cursor-pointer transition-all"
                    style={{ background: 'rgba(57,255,20,0.12)', border: '1px solid rgba(57,255,20,0.3)', color: '#39ff14' }}
                  >
                    <i className="ri-navigation-line" />
                    Построить маршрут
                  </a>
                </div>
              )}
            </div>

            {/* Zone info cards row */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {mapZones.map((zone) => (
                <button
                  key={zone.id}
                  onClick={() => setActiveZone(activeZone === zone.id ? null : zone.id)}
                  className="p-3 rounded-xl text-left cursor-pointer transition-all duration-300"
                  style={{
                    background: activeZone === zone.id ? `${zone.color}12` : 'rgba(255,255,255,0.03)',
                    border: `1px solid ${activeZone === zone.id ? zone.color + '50' : 'rgba(255,255,255,0.07)'}`,
                  }}
                >
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg mb-2" style={{ background: `${zone.color}15` }}>
                    <i className={`${zone.icon} text-sm`} style={{ color: zone.color }} />
                  </div>
                  <p className="font-mono text-[10px] text-white/50 leading-tight">{zone.label}</p>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliveryMap;
